module.exports = __webpack_public_path__ + "img/step2-03.576216f4.png";